import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import GroupCrudTable from "@/components/permissions/groupCrudTable";
import { useTranslation } from "react-i18next";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

interface Props {
  title?: string;
}

const PermissionGroupList: FC<Props> = () => {
  const { t } = useTranslation();
  usePageHeading(t("permissions_groups"));
  return (
    <RestrictedPage permissionRequired="frontend_view_permission_group">
      <GroupCrudTable />
    </RestrictedPage>
  );
};

export default PermissionGroupList;
